export const tableStyle = {
  table: {
    boxShadow: 'lg',
    mx: 'auto',
    my: 3,
    overflow: 'hidden',
    rounded: 'xl'
  },
  thead: {
    bg: 'var(--tableHead)'
  },
  th: {
    borderRight: '1px solid',
    color: 'var(--primaryTextColor)'
  },
  tbody: {
    border: 'none',
    bg: 'var(--tableBody)'
  },
  'tr, td, th': {
    borderColor: '#00000014 !important',
    '&:last-child': {
      borderRight: 'none'
    }
  },
  td: {
    color: 'var(--primaryTextColor)'
  },
  'td .text-gray-700': {
    color: 'var(--secondaryTextColor)'
  }
};
